import React, { Component } from "react";
import { Link } from "react-router-dom";
//import { motion } from "framer-motion";
import Jumbotron from "react-bootstrap/Jumbotron";
import NAERlogo from "../Images/NAER logo.png";

class Home extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <div className="text-center">
          <img className="img-fluid" src={NAERlogo} alt="logo" />
        </div>
        <Jumbotron>
          <div>
            <h1 className="page-header text-center text-uppercase home-h1">
              New-Age Academy of Education and Research -Winneba, Ghana
            </h1>
            <p className="lead text-justify">
              The Centre for Educational Research and Speech and Language
              Services for Families and Persons with Communication Disorders and
              Dyslexia Management under the NEW-AGE ACADEMY of EDUCATION AND
              RESEARCH (NAER) started in the early part of 2021. NAER has been a
              long time <u>dream of Professor Grace Yawo Gadagbui</u> since 1975
              after the Specialist Training for the Deaf at Mampong- Akwapim in
              the Eastern Region, and this yearning persisted when she taught
              the children with hearing impairment in the Volta school for the
              Deaf, Hohoe in the Volta Region of Ghana. After further training
              in Communication Disorders and Sciences between 1981 to 1985, she
              obtained BSc and MSc, in Carbondale, Illinois USA as a Speech and
              Language Therapist.
            </p>
            <p>
              <Link to="/intro">
                <button className="home-button lead">Learn more</button>
              </Link>
            </p>
          </div>
        </Jumbotron>
      </div>
    );
  }
}

export default Home;
